import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLazySearchPoisQuery } from 'redux/services/poisService';
import { useLazySearchLinesStopsQuery, useLazySearchNominatimQuery } from 'redux/services/stopsService';
import { categoryState } from 'redux/slices/categorySlice';
import { lineState } from 'redux/slices/linesSlice';
import { pushRecentSearch } from 'redux/slices/recentSearchsSlice';
import { transportModeState } from 'redux/slices/transportmodeSlice';
import { IItemResultSearch, IPosition } from 'types/interfaces';
import { MAX_ELEMENTS_SEARCH, SEARCH_LINESSTOPS_TYPES, TYPES_MARKERS } from 'utils/constants';
import IconPresenter from 'hooks/IconPresenter';
import { useLanguage } from 'context/languageContext';
import { ReactComponent as Ic_Location_Dark } from 'resources/icons/Ic_Location_Dark.svg';
import { useLazyGetSearchNewBytxtQuery } from 'redux/services/newsService';
import { ReactComponent as Ic_Search } from 'resources/icons/Ic_search_filled.svg';
import {
  useLazyGetQuestionsByTextQuery,
} from 'redux/services/webService';

interface IArrayMainSearch {
  stopsLines: Array<IItemResultSearch>;
  nominatim: Array<IItemResultSearch>;
  pois: Array<IItemResultSearch>;
  news: Array<IItemResultSearch>;
  faqs: Array<IItemResultSearch>;
}
const initialArrayMainSearch: IArrayMainSearch = {
  stopsLines: [],
  nominatim: [],
  pois: [],
  news: [],
  faqs: [],
};

export default function useSearch(clickItem, clickNav, searchType = SEARCH_LINESSTOPS_TYPES.both, maxResults = MAX_ELEMENTS_SEARCH, page = 1) {
  const [itemsSearch, setItemsSearch] = useState<IArrayMainSearch>(initialArrayMainSearch);
  const [searching, setSearching] = useState(false);
  const [searchingText, setSearchingText] = useState('');
  const [loadingSerach, setLoadingSerach] = useState(false);
  const [currentNominatim, setCurrentNominatim] = useState<any>([]);
  const currentLanguage = useLanguage();

  const selectorLines = useSelector(lineState);
  const selectorTransportModes = useSelector(transportModeState);
  const selectorCategoryPois = useSelector(categoryState);

  const [SearchLinesStops] = useLazySearchLinesStopsQuery();
  const [SearchNominatim] = useLazySearchNominatimQuery();
  const [GetSearchNewBytxt] = useLazyGetSearchNewBytxtQuery();
  const [SearchPois] = useLazySearchPoisQuery();
  const [getQuestionByText] = useLazyGetQuestionsByTextQuery();
  const iconP = IconPresenter();
  const dispatch = useDispatch();
  const controllerRef = useRef() as any;
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | undefined>();

  useEffect(() => {
    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    if (selectorCategoryPois?.length > 0 && selectorTransportModes?.length > 0) {
      const cargaIconos = async () => {
        let idIcons: Array<number> = [];
        selectorTransportModes.forEach((transport) => {
          if (
            !idIcons.includes(transport?.iconId) &&
            transport?.iconId > 0 &&
            transport?.iconId !== undefined
          ) {
            idIcons.push(transport?.iconId);
          }
        });

        selectorCategoryPois.forEach((category) => {
          if (
            !idIcons.includes(category?.iconId) &&
            category?.iconId > 0 &&
            category?.iconId !== undefined
          ) {
            idIcons.push(category?.iconId);
          }
        });
        await iconP.getArrayIdIcons(idIcons);
      };
      cargaIconos();
    }
  }, [selectorCategoryPois, selectorTransportModes]);

  useEffect(() => {
    if(page > 1 && currentNominatim?.length > 0) {
      SearchNominatimByPage();
    }
  },[page]);

  const debounce = <T extends any[]>(func: (...args: T) => void, delay: number) => {
    
    return function (...args: T) {
      // Limpia el temporizador anterior
      if (timer) {
        clearTimeout(timer);
      }
  
      // Configura un nuevo temporizador
      setTimer(setTimeout(() => {
        func(...args); // Ejecuta la función después del retraso
      }, delay));
    };
  };

  const debounceSearch = debounce(async (query: string, includeAll: boolean) => {
    try {
      const response = await SearchLinesStops({ txt: query, type: searchType });
      const responsePois = await SearchPois({ txt: query, language: currentLanguage });
      if (includeAll) {
        const responseNews = await GetSearchNewBytxt({ txt: query, language: currentLanguage });
        const responseFaqs = await getQuestionByText({ text: query, language: currentLanguage });
        const responseNominatim = await SearchNominatim({ txt: query, language: currentLanguage, page, perPage: 5 });
        search(responseNominatim, 'nominatim');
        search(responseNews, 'news');
        search(responseFaqs, 'faqs');
        setCurrentNominatim(search(responseNominatim, 'nominatim'));
      }
      search(response, 'stopsLines');
      search(responsePois, 'pois');
    } catch (error: any) {
      if (error.name === 'AbortError') {
      } else {
        console.error('Error en la búsqueda:', error);
      }
    }
  }, 500);

  const SearchNominatimByPage = async ()=> {
    try {
      const responseNominatim = await SearchNominatim({ txt: searchingText, language: currentLanguage, page, perPage: maxResults });
      const data = responseNominatim.data?.length > 0 ? responseNominatim.data : [];
      setCurrentNominatim([...data, ...currentNominatim]);

    } catch (error: any) {
      if (error.name === 'AbortError') {
      } else {
        console.error('Error en la búsqueda:', error);
      }
    }
  };

  const search = (response, key) => {
    try {
      setLoadingSerach(true);
      const stops = response.data?.slice(0, maxResults);

      const resultsSearch = stops?.map((stop) => {
        var itemResultSearch: IItemResultSearch;
        let position = {};
        if (key === TYPES_MARKERS.NOMINATIM) {

          itemResultSearch = {
            id: Number(String(stop?.longitude + stop?.latitide).replaceAll('.','')),
            name: stop?.streetName,
            desc: undefined,
            code: stop.category,
            transportMode: stop.type,
            type: TYPES_MARKERS.NOMINATIM,
            position: {
              lng: Number(stop?.longitude),
              lat: Number(stop?.latitide),
            } ,
            routeColor: undefined,
            routeTextColor: undefined,
            icon:Ic_Location_Dark
          };

          itemResultSearch.onClick = () => {
            clickItem(itemResultSearch);
            dispatch(pushRecentSearch(itemResultSearch));
          };

          itemResultSearch.onClickNav = () => {
            clickNav(itemResultSearch);
            dispatch(pushRecentSearch(itemResultSearch));
          };
        }
        else if (key === 'news') {
          itemResultSearch = {
            id: stop.id,
            name: stop.title,
            desc: stop.link,
            code: '',
            transportMode: 0,
            type: 'news',
            position: undefined,
            routeColor: undefined,
            routeTextColor: undefined,
            icon: Ic_Search,
          };
          itemResultSearch.onClick = () => {
            clickItem(itemResultSearch);
          };
          itemResultSearch.onClickNav = () => {
            clickNav(itemResultSearch);
          };
        } else if(key === 'faqs') {
            itemResultSearch = {
              id: stop.faqId,
              code: stop.categories[0],
              name: stop.question,
              transportMode: 0,
              type: 'faqs',
              position: undefined,
              routeColor: undefined,
              routeTextColor: undefined,
              icon: Ic_Search,
            };
            itemResultSearch.onClick = () => {
              clickItem(itemResultSearch);
            };
            itemResultSearch.onClickNav = () => {
              clickNav(itemResultSearch);
            };
          } else {
            if (stop.type !== TYPES_MARKERS.ROUTE) {
              position = {
                lng: key === 'pois' ? Number(stop?.lon) : Number(stop?.longitude),
                lat: key === 'pois' ? Number(stop?.lat) : Number(stop?.latitude),
              };
            }
            let routeColor = undefined;
            let routeTextColor = undefined;

            if (stop.type === TYPES_MARKERS.ROUTE) {
              const lineaInfo = selectorLines.find((linea) => linea.id === stop.id);
              routeColor = lineaInfo.routeColor;
              routeTextColor = lineaInfo.routeTextColor;
            }

            if (key === 'pois') {
              const categoryInfo = selectorCategoryPois.find((category) => Number(category.id) === Number(stop.type));
              routeColor = categoryInfo?.color;
            }

            itemResultSearch = {
              id: stop.id,
              name: stop.name !== undefined ? stop.name : stop?.description,
              desc: key === 'pois' ? stop?.address : stop?.description,
              code: stop.code,
              transportMode: key === 'pois' ? stop.type : stop.transportMode,
              type: key === 'pois' ? TYPES_MARKERS.POI : stop.type ?? TYPES_MARKERS.STOP,
              position: position as IPosition,
              routeColor: routeColor,
              routeTextColor: routeTextColor,
              icon:
                key === 'pois'
                  ? Ic_Location_Dark
                  : key === 'stopsLines'
                  ? stop.transportMode
                  : Ic_Search,
            };

            itemResultSearch.onClick = () => {
              clickItem(itemResultSearch);
              dispatch(pushRecentSearch(itemResultSearch));
            };

            itemResultSearch.onClickNav = () => {
              clickNav(itemResultSearch);
              dispatch(pushRecentSearch(itemResultSearch));
            };
        }

        return itemResultSearch;
      });

      setSearching(true);

      const arrayMainSearchAux = { [key]: resultsSearch };
      setItemsSearch((itemSeach) => ({
        ...itemSeach,
        ...arrayMainSearchAux,
      }));
    } catch (error) {
      return error;
    } finally {
      setLoadingSerach(false);
    }
  };

  const clearItemsSearch = () => {
    setSearching(false);
    setItemsSearch(initialArrayMainSearch);
  };

  const searchAction = (value, includeAll: boolean) => {
    if (value) {
      const valueIsNumber = !isNaN(value);
      const NUMBER_OF_CHARACTER = valueIsNumber ? 1 : 3;
      if (value.length >= NUMBER_OF_CHARACTER) {
        setSearchingText(value);
        debounceSearch(value, includeAll);
      }
    } else {
      // controllerRef.current.abort();
      clearTimeout(timer);
      clearItemsSearch();
    }
  };

  return [searchAction, itemsSearch, searching, clearItemsSearch, loadingSerach] as const;
}
